export default {
	"order.CongratulationsOnYourSuccessfulPurchase": "恭喜你購買成功",
	"order.TheCouponHasBeenPlacedInYourPersonalAccountYouCanLogInToTheCallAppOrAppletToViewIt": "優惠券已放入您的個人帳戶中，可登錄【叫叫】App或小程序進行查看",
	"order.checkOrder": "查看訂單",
	"order.LongPressOrScanTheQRCodeToIdentifyTheCallingApplet": "長按或掃描二維碼識別叫叫小程序"
}